var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "moreInfo" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("MoreInfo"),
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.viewClose,
          },
        },
        [
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-longtime.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("total_print_time"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.longTime)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-wireRod.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("total_filament_consumption"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.wireRod)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-printeTimes.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("print_count"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.printeTimes)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-bindTime.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("binding_time"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.bindTime)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-firmware.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("FirmwareVersion"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.firmware)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-CN.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("CNCode"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.CN)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "itemLeft" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/imgs/moreInfo/icon-Mac.png"),
                  },
                }),
              ]),
              _c("div", { staticClass: "itemRight" }, [
                _c("div", { staticClass: "rightTop" }, [
                  _vm._v(_vm._s(_vm.$t("mac_address"))),
                ]),
                _c("div", { staticClass: "rightBottom" }, [
                  _vm._v(_vm._s(_vm.Mac)),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "closeBtn",
                on: {
                  click: function ($event) {
                    return _vm.viewClose()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("close")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }